/* global Vue */
import IndexEditor from './IndexEditor'

class Bridge {
	constructor (bridgeE, options) {
		options = Object.assign({
			coverSize: '600x134',
		}, options)

		// 入力データの正規化
		const data = (bridgeE => {
			try {
				return JSON.parse(bridgeE.value)
			} catch (e) {
				return {
					T: 'Index',
					sections: [],
					uploads: []
				}
			}
		})(bridgeE)

		// データを旧型式から変換する
		data.sections = data.sections.map(section => {
			if (!section.sectionId) {
				section.sectionId = section.id
				delete section.id
			}
			section.items = section.items.map(item => {
				if (!item.itemId) {
					item.itemId = item.pageId ? 'page_' + item.pageId : null
					delete item.pageId
				}
				return item
			})
			return section
		})

		this.bridgeE = bridgeE
		bridgeE.setAttribute('type', 'hidden')

		this.container = this.createContainer()
		this.app = new Vue({
			data () {
				return {
					data,
					options
				}
			},
			el: this.container,
			components: {
				IndexEditor
			},
			template: '<IndexEditor v-model="data" v-bind="options" />',
			watch: {
				data: {
					deep: true,
					handler () {
						const data = Object.assign({}, this.data)
						data.uploads = data.sections
							.map(section => section.cover)
							.filter(cover => cover !== null)
						bridgeE.value = JSON.stringify(data)
					}
				}
			}
		})
	}

	createContainer () {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
